import _extends from '@babel/runtime/helpers/extends';
import { useMemo } from 'react';
import { renderCharacterLimitEndAdornment } from '../../renderers.js';

var useCharacterLimit = function useCharacterLimit(params) {
  var characterLimit = params.characterLimit,
    endAdornmentProp = params.endAdornment,
    className = params.endAdornmentClassName,
    inputPropsProp = params.inputProps,
    value = params.value,
    variant = params.variant;
  var endAdornment = useMemo(function () {
    if (!characterLimit) {
      return endAdornmentProp;
    }
    return renderCharacterLimitEndAdornment({
      characterLimit: characterLimit,
      className: className,
      value: value,
      variant: variant
    });
  }, [characterLimit, className, endAdornmentProp, value, variant]);
  var inputProps = useMemo(function () {
    return characterLimit ? _extends({
      maxLength: characterLimit
    }, inputPropsProp) : inputPropsProp;
  }, [characterLimit, inputPropsProp]);
  return {
    endAdornment: endAdornment,
    inputProps: inputProps
  };
};

export { useCharacterLimit as default };
//# sourceMappingURL=index.js.map
